/* eslint-disable vue/multi-word-component-names */

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { faFontAwesome } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faUserSecret);
library.add(faFontAwesome);

import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import InputRequiredText from "@/components/elements/InputRequiredText.vue";
import InputRequiredNumber from "@/components/elements/InputRequiredNumber.vue";
import InputRequiredTextArea from "@/components/elements/InputRequiredTextArea.vue";
import InputTextGroup from "@/components/elements/InputTextGroup.vue";
import InputChips from "@/components/elements/input-chips.vue";
import DropDownRequire from "@/components/elements/drop-down.vue";
import InputDate from "@/components/elements/input-date.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import SplitButton from "primevue/splitbutton";
import moment from "moment-timezone";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmPopup from "@/components/modal-popup/confirm-popup.vue";
import MultiSelect from "primevue/multiselect";
import Tooltip from "primevue/tooltip";
import Chart from "primevue/chart";
// import ToastService from "primevue/toastservice";
// import Toast from "primevue/toast";
import Chip from "primevue/chip";
import ProgressBar from "primevue/progressbar";
import Chips from "primevue/chips";
import FileUpload from "primevue/fileupload";
import Textarea from "primevue/textarea";
import RadioButton from "primevue/radiobutton";
import Slider from "primevue/slider";
import VueQRCodeComponent from "vue-qrcode-component";
import VueClipboard from "vue3-clipboard";
import ColorPicker from "primevue/colorpicker";
import ProgressSpinner from "primevue/progressspinner";
import Breadcrumb from "primevue/breadcrumb";
import ToggleButton from "primevue/togglebutton";
import Paginator from 'primevue/paginator';
import clickOutside from "@/components/directive/useDetectOutsideClick";
import UIRadioButton from "@/components/elements/RadioGroupWrapper.vue";
import InputVue from "@/components/vueComponent/input.vue";
import InputNumberVue from "@/components/vueComponent/number.vue";
import ToggleVue from "@/components/vueComponent/toggle.vue";
import CheckboxVue from "@/components/vueComponent/checkbox.vue";
import InputGroup from "@/components/vueComponent/inputgroup.vue";
import SelectVue from "@/components/vueComponent/select.vue";
import ButtonVue from "@/components/vueComponent/button.vue";
import ChipsVue from "@/components/vueComponent/chips.vue";
import TextareaVue from "@/components/vueComponent/textarea.vue";
import MultiSelectVue from "@/components/vueComponent/multiselect.vue";
import RadioVue from "@/components/vueComponent/radio.vue";
import DataTableVue from "@/components/vueComponent/dataTable.vue";
import DataTableMiniVue from "@/components/vueComponent/dataTableMini.vue";

import DialogVue from "@/components/vueComponent/dialog.vue";
import ColorPickerVue from "@/components/vueComponent/colorpicker.vue";
import TabVue from "@/components/vueComponent/tabView.vue";
import TabPanelVue from "@/components/vueComponent/tabPanel.vue";
import SliderVue from "@/components/vueComponent/slider.vue";
import DateVue from "@/components/vueComponent/date.vue";
import ToastPlugin from './plugins/toast.js';
import ToastMessage from "@/components/vueComponent/toast.vue";
import toastService from './services/toast';


import Badge from "primevue/badge";
import BadgeDirective from "primevue/badgedirective";
window.$ = window.jQuery = require("jquery");

import "primevue/resources/themes/bootstrap4-light-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeflex/primeflex.min.css";
import "primeicons/primeicons.css"; //icons
import "@/assets/css/global.css";
import "@/assets/css/font-awesome.min.css";
import "vue-search-select/dist/VueSearchSelect.css";
// import "@voyado/voyado-vue-component"; // Ensure this is correctly imported
const app = createApp(App);
// app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith("ui-");
app.config.globalProperties.$toast = {
  add: toastService.add,
};
app.use(store);
app.use(PrimeVue);
app.use(moment);
app.use(ToastPlugin);
// app.use(ToastService);
app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
});

app.component("font-awesome-icon", FontAwesomeIcon);

app.component("PrimeButton", Button);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("InputRequiredText", InputRequiredText);
app.component("InputRequiredNumber", InputRequiredNumber);
app.component("InputRequiredTextArea", InputRequiredTextArea);
app.component("InputTextGroup", InputTextGroup);
app.component("InputChips", InputChips);
app.component("DropDownRequire", DropDownRequire);
app.component("InputDate", InputDate);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("Dropdown", Dropdown);
app.component("Calendar", Calendar);
app.component("Checkbox", Checkbox);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("SplitButton", SplitButton);
app.component("ConfirmationService", ConfirmationService);
app.component("ConfirmPopup", ConfirmPopup);
app.component("MultiSelect", MultiSelect);
app.component("Chart", Chart);
app.directive("tooltip", Tooltip);
app.directive("clickOutside", clickOutside);
app.directive("badge", BadgeDirective);
app.component("Badge", Badge);

// app.component("PrimeToast", Toast);
app.component("Chip", Chip);
app.component("ProgressBar", ProgressBar);
app.component("Chips", Chips);
app.component("FileUpload", FileUpload);
app.component("Textarea", Textarea);
app.component("RadioButton", RadioButton);
app.component("Slider", Slider);
app.component("qr-code", VueQRCodeComponent);
app.component("ColorPicker", ColorPicker);
app.component("ProgressSpinner", ProgressSpinner);
app.component("Breadcrumb", Breadcrumb);
app.component("ToggleButton", ToggleButton);
app.component("Paginator",Paginator);
app.component("uiradiobutton", UIRadioButton);
app.component("InputVue", InputVue);
app.component("InputNumberVue", InputNumberVue);
app.component("ToggleVue", ToggleVue);
app.component("CheckboxVue", CheckboxVue);
app.component("InputGroup", InputGroup);
app.component("SelectVue", SelectVue);
app.component("TextareaVue", TextareaVue);
app.component("ButtonVue", ButtonVue);
app.component("ChipsVue", ChipsVue);
app.component("MultiSelectVue", MultiSelectVue);
app.component("RadioVue", RadioVue);
app.component("DataTableVue", DataTableVue);
app.component("DataTableMiniVue", DataTableMiniVue);
app.component("DialogVue",DialogVue);
app.component("ColorPickerVue",ColorPickerVue);
app.component("TabVue",TabVue);
app.component("TabPanelVue",TabPanelVue);
app.component("SliderVue",SliderVue);
app.component("DateVue",DateVue);
app.component("ToastMessage", ToastMessage);

app.use(router).mount("#app");
